import React, { ReactChild } from 'react';
import { Colors, Theme } from '@inplayer-org/inplayer-ui';
import { transparentize } from 'polished';
import styled, { StyledComponent } from 'styled-components';
import { ifProp } from 'styled-tools';

// data
import { light, dark } from 'data/themes';

export const TabsContainer = styled.div<{ isDarkModeEnabled?: boolean }>`
  text-transform: uppercase;
  font-size: ${({ theme }) => theme.font.sizes.extraSmall};
  letter-spacing: 0.04em;
  color: ${({ isDarkModeEnabled }) =>
    isDarkModeEnabled ? dark.palette.text.main : transparentize(0.45, light.palette.text.main)};
  padding: 2vh 0;
  display: flex;
  justify-content: center;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

interface TabProps {
  active?: boolean;
  borderColor?: string;
}

const Tab: StyledComponent<'label', Theme, TabProps> = styled.label`
  pointer-events: none;
  cursor: pointer;
  padding: 0 5px 2px;
  margin: 0 8px;
  border-bottom: 2px solid ${Colors.gray};
  border-color: ${({ borderColor }: TabProps) => ifProp('active', borderColor || Colors.skyBlue, Colors.gray)};
`;

const BoldTitle = styled(Tab)`
  color: ${Colors.fontDarkGray};
`;

interface OwnProps {
  title?: string;
  children?: ReactChild;
  borderColor?: string;
  displayTitle?: boolean;
  isRegister?: boolean;
  isDarkModeEnabled?: boolean;
}

type Props = OwnProps;

const Header = ({ title, children, borderColor, isRegister, displayTitle = true, isDarkModeEnabled }: Props) => {
  return (
    <HeaderContainer>
      {displayTitle && (
        <TabsContainer isDarkModeEnabled={isDarkModeEnabled}>
          {title ? (
            <BoldTitle active borderColor={borderColor}>
              {title}
            </BoldTitle>
          ) : (
            <>
              <Tab active={!isRegister} borderColor={borderColor}>
                login
              </Tab>
              /
              <Tab active={isRegister} borderColor={borderColor}>
                sign up
              </Tab>
            </>
          )}
        </TabsContainer>
      )}
      {children}
    </HeaderContainer>
  );
};

export default Header;
